/* Filter sidebar helpers (1 Nov 2026).
   Wraps each filter value's product count "(88)" in <span class="vz-facet-count">
   so assets/vz-facets.css can show it as a pill, turns a group's "(2)" selected
   count into "2", and drops the colon from the "Filter:" heading.
   Loaded without defer at the top of the product grid section, and watches the
   page, so it also catches the parts facets.js re-renders after each filter
   change. Purely cosmetic: if it fails, the filters work and show "(88)". */
(() => {
  const COUNT = /^\s*\(([\d.,]+)\)\s*$/;
  const DONE = 'data-vz-done';

  function enhance() {
    document.querySelectorAll('.facet-checkbox__text:not([' + DONE + '])').forEach((el) => {
      el.setAttribute(DONE, '');
      el.childNodes.forEach((node) => {
        if (node.nodeType !== 3) return;
        const m = node.textContent.match(COUNT);
        if (!m) return;
        const pill = document.createElement('span');
        pill.className = 'vz-facet-count';
        pill.textContent = m[1];
        node.replaceWith(pill);
      });
    });

    document.querySelectorAll('.facets__selected:not([' + DONE + '])').forEach((el) => {
      el.setAttribute(DONE, '');
      const m = el.textContent.match(/(\d+)/);
      if (m) el.textContent = m[1];
    });

    document.querySelectorAll('.facets__heading--vertical:not([' + DONE + '])').forEach((el) => {
      el.setAttribute(DONE, '');
      if (el.children.length === 0) el.textContent = el.textContent.trim().replace(/[:：]\s*$/, '');
    });
  }

  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      enhance();
    });
  };

  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', enhance);
  schedule();
})();
